export const Constants = {
  responsibleName: 'Responsável:',
  emailResponsible: 'Email responsável:',
  phoneResponsible: 'Telefone responsável: ',
};
